import SectionBox from './SectionBox.component';

export default SectionBox;
